/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Action } from '@ngrx/store';
import { Customer } from '@shared/models';

export const LOAD_CUSTOMERS_PARTIAL = '[Customers Partial] Load';
export const LOAD_CUSTOMERS_PARTIAL_SUCCESS = '[Customers Partial] Load success';
export const LOAD_CUSTOMERS_PARTIAL_FAILURE = '[Customers Partial] Load failure';

export const LOAD_CUSTOMERS = '[Customers] Load';
export const LOAD_CUSTOMERS_SUCCESS = '[Customers] Load success';
export const LOAD_CUSTOMERS_FAILURE = '[Customers] Load failure';

export class LoadCustomers implements Action {
  readonly type = LOAD_CUSTOMERS;
}

export class LoadCustomersSuccess implements Action {
  readonly type = LOAD_CUSTOMERS_SUCCESS;
  constructor(public customers: Customer[]) {}
}

export class LoadCustomersFailure implements Action {
  readonly type = LOAD_CUSTOMERS_FAILURE;
}

export class LoadCustomersPartial implements Action {
  readonly type = LOAD_CUSTOMERS_PARTIAL;
  constructor(public searchString: string) {}
}

export class LoadCustomersPartialSuccess implements Action {
  readonly type = LOAD_CUSTOMERS_PARTIAL_SUCCESS;
  constructor(public customers: Customer[]) {}
}

export class LoadCustomersPartialFailure implements Action {
  readonly type = LOAD_CUSTOMERS_PARTIAL_FAILURE;
}

export type CustomersActions = LoadCustomers | LoadCustomersSuccess | LoadCustomersFailure | LoadCustomersPartial |
  LoadCustomersPartialSuccess | LoadCustomersPartialFailure;
